/** Endpoint #30 and the media reference carried by every post/profile DTO (§9). */
import { z } from 'zod';
import { BooleanParamSchema, IdSchema } from './common.js';
/** #30 `GET /api/media/:assetId` */
export const MediaParamsSchema = z.object({ assetId: IdSchema });
export const MediaQuerySchema = z.object({
    /** `?refresh=1` re-attempts a `failed` asset (§9.2). */
    refresh: BooleanParamSchema.optional(),
});
/** Allowed CDN host suffixes (§9.1) — code constant, not a setting. */
export const MEDIA_ALLOWED_SUFFIXES = ['.licdn.com'];
export const MEDIA_MAX_BYTES = 25 * 1024 * 1024;
export const MEDIA_FETCH_TIMEOUT_MS = 30_000;
export const MEDIA_MAX_REDIRECTS = 3;
//# sourceMappingURL=media.js.map